export class TokenExpired extends Error {
  constructor(message = 'Token expired') {
    super(message);
  }
}

export class TokenNotFound extends Error {
  constructor(message = 'No available token found') {
    super(message);
  }
}
